<div class="modal-content m-0 p-2">
  <div class="modal-body">
    <b class="mb-2 d-block">{{ title | translate }}</b>
    <i class="mb-2 d-block">
      {{ (progressSubject | async)?.status ?? '' | translate }}
    </i>
    <div class="pt-4 loading"></div>
    @if (password) {
      <div class="mt-2">
        {{ 'shared.progressDialog.passwordProtected' | translate }}:
        <a class="cursor-pointer" (click)="copyToClipboard(password)"
          ><span>{{ password }}</span> <i class="fa-light fa-copy ps-1"></i
        ></a>
      </div>
    }
  </div>
</div>
